import React from 'react'
import { useLocation } from 'react-router-dom'
import { EducationFeature } from 'education-tools'
import { useCMSEntries } from 'mage-cms'
import HelpPopup from './HelpPopup'

export default function ExperimentationFeaturePopups() {
  const location = useLocation()
  const popups = useCMSEntries({
    contentType: 'UHQMPopup',
    filters: {
      'experimentationFeature[exists]': true
    }
  })

  if (!popups) return null

  const filteredPopups = popups.filter(
    popup => !popup.paths || popup.paths.includes(location.pathname)
  )

  return filteredPopups.map(popup => (
    <EducationFeature key={popup.id} name={popup.experimentationFeature}>
      <HelpPopup slug={popup.slug} />
    </EducationFeature>
  ))
}
